// MA-238 ma241-redemption-route slice — /join/:code, the destination the
// send-home card's QR/typed code points to. Public (see App.jsx's /join/
// gate-ladder bypass — mirrors the /privacy /terms /coppa-notice pattern).
// See JoinRedemption.tsx's header comment for exactly what this route does
// and does not do.
import { createFileRoute } from "@tanstack/react-router";
import { JoinRedemption } from "@/screens/JoinRedemption";

function JoinRoute() {
  const { code } = Route.useParams();
  return <JoinRedemption code={code} />;
}

export const Route = createFileRoute("/join/$code")({
  component: JoinRoute,
});
